import icon from 'vue-svgicon';

icon.register({
    'regular/tools-wench': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.439 3.9l-3.317 3.316h-2.338V4.878L20.1 1.561a5.752 5.752 0 0 0-8.168 7L1.589 18.9A2.48 2.48 0 0 0 5.1 22.411l10.34-10.344a5.752 5.752 0 0 0 7-8.168z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
